<template>
  <div id="filter-container">
    <img
      @click="$emit('closeModal')"
      class="close-icon"
      src="../../../assets/icons/close.png"
      alt="Close"
    >
    <v-form v-model="valid">
      <div v-if="filterType == 'date'">
        <h1 class="header-text">
          <span>Filter po datumu
            <div class="header-text-line"></div>
          </span>
        </h1>
        <v-menu
          ref="dateMenu"
          :close-on-content-click="true"
          v-model="dateMenu"
          :nudge-right="40"
          :return-value.sync="filter.selectedDate"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="filter.selectedDate"
            :rules="rules.required"
            label="Odaberite datum"
            prepend-icon="event"
            readonly
          ></v-text-field>

          <v-date-picker
            v-model="filter.selectedDate"
            @input="$refs.dateMenu.save(filter.selectedDate)"
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </div>
      <div v-if="filterType == 'studio'">
        <h1 class="header-text">
          <span>Filter po studiu
            <div class="header-text-line"></div>
          </span>
        </h1>
        <v-select
          label="Odaberite studio"
          v-model="filter.selectedStudio"
          :rules="rules.required"
          :items="studio"
          item-text="Name"
          item-value="StudioId"
        ></v-select>
      </div>
      <div v-if="filterType == 'appointmentType'">
        <h1 class="header-text">
          <span>Filter po tipu termina
            <div class="header-text-line"></div>
          </span>
        </h1>
        <v-select
          label="Odaberite tip termina"
          v-model="filter.selectedAppointmentType"
          :rules="rules.required"
          :items="appointmentType"
          item-text="Name"
          item-value="AppointmentTypeId"
        ></v-select>
      </div>
      <div class="text-right">
        <v-btn class="main-btn" :disabled="!valid" @click="filterAppointments">Filter</v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  props: ["filterType", "dialog"],
  data() {
    return {
      dateMenu: false,
      studio: [],
      appointmentType: [],
      filter: {
        selectedDate: null,
        selectedStudio: null,
        selectedAppointmentType: null
      },
      valid: false,
      rules: {
        required: [v => !!v || "Polje je obavezno"]
      }
    };
  },
  methods: {
    getStudio() {
      this.$store.state.services.studioService.getForDropdown().then(response => {
        this.studio = response.data;
      });
    },
    getAppointmentType() {
      this.$store.state.services.appointmentTypeService
        .getAll()
        .then(response => {
          this.appointmentType = response.data;
        });
    },
    filterAppointments() {
      this.$emit("resetSelectedPage");
      this.$emit("filterAppointments", this.filter);
    }
  },
  watch: {
    filterType(newVal, oldVal) {
      if (newVal == "studio") {
        this.getStudio();
      } else if (newVal == "appointmentType") {
        this.getAppointmentType();
      }
    },
    dialog() {
      if (this.dialog == false) {
        this.filter = {
          selectedDate: null,
          selectedStudio: null,
          selectedAppointmentType: null
        };
      }
    }
  }
};
</script>

<style scoped>
#filter-container {
  background-color: white;
  padding: 25px;
  position: relative;
}
.header-text {
  margin-bottom: 20px;
}
</style>
